/**
 * Acento solto, de espaçamento, e a marca combinante que ele representa. O
 * PDF feito no LaTeX desenha o acento como glifo à parte, e a camada de texto
 * o devolve antes da letra: "Exerc´ıcio", "instala¸c˜ao", "Inferˆencia".
 */
const VOGAIS = "aeiouAEIOU\u0131";
const ACENTO_SOLTO = {
    "\u00b4": { marca: "\u0301", letras: VOGAIS }, // agudo
    "`": { marca: "\u0300", letras: VOGAIS }, // grave
    "\u02c6": { marca: "\u0302", letras: VOGAIS }, // circunflexo
    "\u02dc": { marca: "\u0303", letras: "aoAOnN" }, // til
    "\u00a8": { marca: "\u0308", letras: VOGAIS }, // trema
    "\u00b8": { marca: "\u0327", letras: "cC" }, // cedilha
};
/**
 * Junta o acento solto à letra que vem logo depois. O "ı" sem pingo, que o
 * LaTeX usa sob o acento, volta a ser "i". Cada acento só se junta às letras
 * que o português acentua com ele: a crase de "`npm`" fica como está.
 */
export function juntarAcentosSoltos(texto) {
    return texto.replace(/([\u00b4`\u02c6\u02dc\u00a8\u00b8])([A-Za-z\u0131])/g, (par, acento, letra) => {
        const { marca, letras } = ACENTO_SOLTO[acento];
        if (!letras.includes(letra))
            return par;
        return ((letra === "\u0131" ? "i" : letra) + marca).normalize("NFC");
    });
}
/** Junta as páginas: cada item com fim de linha quebra a linha, e uma linha em branco separa as páginas. */
export function textoDasPaginas(paginas) {
    return juntarAcentosSoltos(textoDasPaginasCru(paginas));
}
function textoDasPaginasCru(paginas) {
    return paginas
        .map((itens) => itens
        .map((i) => i.str + (i.hasEOL ? "\n" : ""))
        .join("")
        .split("\n")
        .map((linha) => linha.trimEnd())
        .join("\n")
        .trim())
        .filter((p) => p.length > 0)
        .join("\n\n")
        .replace(/\n{3,}/g, "\n\n");
}
/**
 * Média abaixo da qual o PDF é tratado como escaneado. Uma página de prova
 * digital tem milhares de caracteres; a escaneada tem zero, ou só o número da
 * página e um cabeçalho que algum programa carimbou por cima da imagem.
 */
const MINIMO_POR_PAGINA = 100;
/** Sem camada de texto que preste: é imagem, e só um modelo de visão lê. */
export function pareceEscaneado(texto, paginas) {
    if (paginas === 0)
        return true;
    return texto.replace(/\s/g, "").length / paginas < MINIMO_POR_PAGINA;
}
//# sourceMappingURL=pdf-texto.js.map